<template>
  <div class="position-relative">
    <BaseTopLine> </BaseTopLine>
    <div class="tw-relative tw-mb-[15px]">
      <vue-tabs @input="handleTabChange" class="vue-tabs-type-1">
        <v-tab :title="dataLang['register_object_owners_text_3']" />
        <v-tab :title="dataLang['register_object_owners_text_4']" />
        <v-tab :title="dataLang['register_object_owners_text_5']" />
      </vue-tabs>
    </div>

    <div
      class="tw-px-[26px] tw-mt-[15px] tw-flex tw-items-center tw-gap-[10px]"
    >
      <button class="tw-app-btn-primary" @click="onOpenCreateOwnerModal">
        <img
          :src="require(`@/assets/icons/addwhite.svg`)"
          width="13.5"
          height="13.5"
          class="tw-my-[-5px]"
        />
        Добавить
      </button>
      <button
        class="tw-app-btn-primary-outline"
        @click="
          activeSelectRowsMultiple.length
            ? $modal.show('deleteRow')
            : $toast.error('Выберите хотя-бы одно поле')
        "
      >
        <img
          :src="require(`@/assets/icons/adddel.svg`)"
          width="13.5"
          height="13.5"
        />
        {{ dataLang["registry_ads_text2"] }}
      </button>
    </div>

    <div
      class="position-relative tw-px-[26px] tw-py-[15px]"
      style="min-height: 250px"
    >
      <BaseLoader v-if="localLoading"></BaseLoader>
      <!-- <div class="tw-flex tw-justify-end tw-my-[15px]">
        <TwBasePagination
          :page-count="Math.ceil(paginationInfo.total / paginationInfo.limit)"
          :pagination-params="paginationInfo"
          @updateLimitValue="(paginationInfo.limit = $event), loadData(1)"
          :page-range="10"
          :click-handler="loadData"
        >
        </TwBasePagination>
      </div> -->

      <ve-table
        class="fixed-header rest-style-table"
        style="width: 100%"
        :columns="columns"
        :table-data="dataTable"
        :border-x="true"
        :border-y="true"
        row-key-field-name="object_owners__id"
        ref="mainTable"
        :eventCustomOption="eventCustomOption"
        v-if="!localLoading"
        :cell-style-option="cellStyleOption"
        :checkbox-option="{
          selectedRowChange: selectedRowChange,
          selectedAllChange: selectedAllChange,
          hideSelectAll: false,
        }"
        :clickHighlight="false"
        :rowStyleOption="{
          hoverHighlight: true,
        }"
        :cellSelectionOption="{ enable: false }"
      >
      </ve-table>
    </div>

    <BaseModal
      name="pincode"
      width="420"
      :clickToClose="false"
      :shiftY="0.5"
      :adaptive="true"
      @beforeOpen="() => {}"
      height="295"
      classes="bg-transparent shadow-none"
    >
      <div class="bg-white rounded-25 pt-20 pb-20 px-30 h-100">
        <div class="d-flex justify-content-end">
          <button
            type="button"
            class="btn-close"
            @click="$modal.hide('pincode')"
          ></button>
        </div>
        <div class="d-flex h-100 flex-column justify-content-center pb-10">
          <p class="mb-30 text-center">Введите PIN</p>
          <div class="d-flex flex-column align-items-center">
            <BaseInputNew
              placeholder=""
              :width="'225'"
              class="mb-10"
              :input-name="'pincode'"
              @input="(data) => (pincode = data.value)"
              value=""
              name-sign=""
            >
            </BaseInputNew>
            <div class="d-flex justify-content-end gap-15">
              <div
                @click="$modal.hide('pincode')"
                class="btn btn-sm btn-opposite px-20 rounded-10 d-flex align-items-center justify-content-center"
              >
                {{ dataLang["vehile_modal_btn_reset"] }}
              </div>
              <div
                @click="() => (pincode ? acceptNext() : '')"
                class="btn btn-sm btn-primary action-hover px-20 rounded-10 d-flex align-items-center justify-content-center"
              >
                {{ dataLang["vehile_modal_btn_save"] }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </BaseModal>

    <BaseModal
      name="deleteRow"
      width="420"
      :clickToClose="false"
      :shiftY="0.5"
      :adaptive="true"
      @beforeOpen="({ params }) => (typePin = params.type)"
      @beforeClose="
        () => {
          (typePin = ''), (pincode = '');
        }
      "
      height="auto"
      classes="tw-app-modal"
    >
      <div class="tw-app-modal__container">
        <button
          type="button"
          class="btn-close tw-app-modal__close"
          @click="$modal.hide('deleteRow')"
        ></button>
        <div class="tw-text-center">
          <div class="tw-app-modal__title">
            {{ dataLang["reg_fin_text_63"] }}
          </div>

          <div class="tw-app-modal__footer">
            <button
              @click="$modal.hide('deleteRow')"
              class="tw-app-btn-muted tw-app-btn-muted-lg"
            >
              {{ dataLang["reg_fin_text_65"] }}
            </button>
            <button
              @click="deleteRow"
              class="tw-app-btn-primary tw-app-btn-primary-lg"
            >
              {{ dataLang["reg_fin_text_64"] }}
            </button>
          </div>

        </div>
      </div>
    </BaseModal>

    <OwnerModal :activateTab="computedTabParams.url" @close="loadData" />
  </div>
</template>

<script>
import { VueTabs, VTab } from "vue-nav-tabs/dist/vue-tabs.js";
import { mapActions, mapState, mapGetters } from "vuex";
import { VeTable } from "vue-easytable";
import GeneralService from "@/api/GeneralService";
import EventBus from "@/event-bus";
import { debounce } from "lodash";
import OwnerModal from "./owner-modals/OwnerModal.vue";

export default {
  components: {
    VeTable,
    OwnerModal,
    VueTabs,
    VTab,
  },

  data() {
    return {
      paginationInfo: {
        count: 0,
        limit: 50,
        total: 0,
        page: 0,
      },
      listPaymentMethods: [
        { label: "BankCard", value: "BankCard" },
        { label: "SPB", value: "SPB" },
      ],
      valueMethods: {},
      typePin: "",
      fullSum: 0,
      callbackForSum: () => {},
      summForPayment: 0,
      summForPaymentWithPercent: 0,
      foundsList: {},
      localLoading: true,
      statisticsFromMainRequest: {},
      dataTable: [],
      activeSelectRowsMultiple: [],
      filter: [],
      activateTab: "",
      updatedValues: {},
      computedAllPage: 1,
      currentPage: 1,
      selectTimeTopFilter: {
        dateCreatedStart: [],
        dateCreatedEnd: [],
      },
      activePagePagination: {},
      pincode: "",
      totalOnType: 0,
      dataForModal: {},
      aboutPageInfo: null,
      dataOfErrors: null,
      senderSmsPreset: null,
      peremText: "",
      typeOpenCancel: "",
      codeFromSms: "",
      selectsDataForModal: {
        owners: [],
        typeVehicles: [],
        objectsVehicle: [],
        sms_presets: [],
      },
      selectsFromModal: {
        owners: [],
        typeVehicles: [],
        objectsVehicle: [],
        sms_presets: [],
      },
      selectsData: {
        typeOfPayment: [],
        typeOrder: [],
        typeObjects: [],
      },
      selectsFilter: {
        typeOfPayment: [],
        typeOrder: [],
        typeObjects: [],
      },
      eventCustomOption: {
        bodyRowEvents: ({ row, rowIndex }) => {
          return {
            dblclick: (event) => {
              this.$modal.show("ownerModal", {
                isCreateMode: false,
                data: row,
              });
            },
          };
        },
      },
      cellStyleOption: {
        bodyCellClass: ({ row, column, rowIndex }) => {},
      },
    };
  },

  methods: {
    /// ОБРАБОТЧИК ПЕРЕХОДА ПО ВКЛАДКАМ
    async handleTabChange(newTab) {
      console.log(newTab, "TABS CHANGE CONSOLE", this.activateTab);
      if (newTab !== this.dataLang["reg_contract_edit_71"]) {
        this.activateTab = newTab;
        await this.loadData();
      }
    },
    selectedRowChange({ row, isSelected, selectedRowKeys }) {
      this.activeSelectRowsMultiple = selectedRowKeys;
    },
    selectedAllChange({ row, isSelected, selectedRowKeys }) {
      this.activeSelectRowsMultiple = selectedRowKeys;
    },

    onOpenCreateOwnerModal() {
      console.log(this.computedTabParams.url);

      this.$modal.show("ownerModal", { isCreateMode: true });
    },

    updateValue(data) {
      this.updatedValues[data.name] = data.value;
    },

    deleteRow() {
      GeneralService.delete(`/object-owners/${this.activeSelectRowsMultiple}`)
        .then((data) => {
          this.$toast.success(data.data.message);
        })
        .catch((e) => {
          this.activeSelectRowsMultiple = [];
          this.$toast.error(e.response.data.message, { duration: 5000 });
        })
        .finally(() => {
          this.activeSelectRowsMultiple = [];
          this.typePin = "";
          this.pincode = "";
          this.$modal.hide("deleteRow");
          this.$modal.hide("pincode");
          this.loadData();
        });
    },

    computedTranslate(values, tranaslate) {
      let keys = Object.keys(values);
      let tranaslateLocal = tranaslate;
      keys.forEach((keyName) => {
        tranaslateLocal = tranaslateLocal.replace(
          `\\${keyName}\\`,
          values[keyName]
        );
      });
      return tranaslateLocal;
    },

    resetFilter() {
      this.$refs.mainTable.$el
        .querySelectorAll("input.base-input--new")
        .forEach((elem, index) => {
          elem.value = "";
        });
      this.$refs.topFilter
        .querySelectorAll("input.base-input--new")
        .forEach((elem, index) => {
          elem.value = "";
        });
      this.filter = [];

      const today = new Date();

      // Рассчитываем смещение до понедельника:
      // - Если сегодня воскресенье (0), отнимаем 6 дней
      // - Для остальных дней: текущий день недели - 1
      const dayOffset = today.getDay() === 0 ? 6 : today.getDay() - 1;

      // Создаем копию текущей даты и вычитаем рассчитанное смещение
      const monday = new Date(today);
      monday.setDate(today.getDate() - dayOffset);

      // Опционально: устанавливаем время на 00:00:00
      monday.setHours(0, 0, 0, 0);

      this.selectTimeTopFilter.dateCreatedStart = this.$time(monday).format(
        `${this.userSetting.company__tempalte_date}`
      );
      this.selectTimeTopFilter.dateCreatedEnd = this.$time().format(
        `${this.userSetting.company__tempalte_date}`
      );
      this.selectsFilter.trackers = [];
      this.selectsFilter.statuses = [];
      this.selectsFilter.typeOfPayment = [];
      this.filterTimes = {
        contractsCreateStart: "",
        contractsCreateEnd: "",
        startsRateTime: "",
        endRateTime: "",
        startsRateFinishTime: "",
        endRateFinishTime: "",
      };
      this.loadData();
    },

    onCloseModal() {
      this.currentId = null;
      this.updatedValues = {};
      this.dataForModal = {};
      this.activeSelectRowsMultiple = [];
      this.selectsFromModal.objectsVehicle = [];
      this.selectsFromModal.typeVehicles = [];
    },
    deleteActionAndModal() {
      if (this.activeSelectRowsMultiple.length) {
        this.$modal.show("acceptDelete");
      } else {
        this.$modal.show("withoutOptionsModal");
      }
    },
    pincodeModalHandler() {
      this.pincode = "";
      this.activeSelectRowsMultiple = [];
    },
    loadData(page = 1) {
      this.localLoading = true;
      this.paginationInfo.page = page;
      Promise.all([
        // /finreestr-funds?where=[{"field":"finreestr_funds__is_coming","value":1}]&fields=finreestr_funds__id,finreestr_funds__name,finreestr_funds__is_coming
      ]).then(() => {
        GeneralService.get(`/object-owners/${this.computedTabParams.url}`, {
          params: {
            limit: this.paginationInfo.limit,
            page: this.paginationInfo.page,
          },
        })
          .then((data) => {
            this.dataTable = data.data.data.rows;
            this.totalOnType = data.data.data.total;
            this.getFinesAll(data.data.data);
            this.localLoading = false;

            this.paginationInfo.count = data.data.data.count;
            this.paginationInfo.limit = data.data.data.limit;
            this.paginationInfo.total = data.data.data.total;
            this.paginationInfo.page = data.data.data.page;
          })
          .catch((e) => {
            this.$toast.error("Неизвестная ошибка при загрузке таблицы", {
              duration: 5000,
            });
          });
      });
    },
    fillFilter(data) {
      let newValueFilter =
        data.type == "like" ? `;percent;${data.value};percent;` : data.value;
      if (!this.filter.find((x) => x.field == data.name)) {
        this.filter.push({
          field: data.name,
          value: newValueFilter,
          ...(data.type == "like" && { operator: "like" }),
          ...(data.operator && { operator: data.operator }),
          ...(data.mod && { mod: data.mod }),
        });
      } else {
        this.filter[this.filter.findIndex((x) => x.field == data.name)].value =
          newValueFilter;
      }
    },

    prepareLabelsForDefaultSelects(data, keyDataFromFetch, toTranslate) {
      for (const key in data) {
        data[key].forEach((element) => {
          element["label"] = element[Object.keys(element).pop()];
          element["key"] = key;
          element["value"] = Object.keys(element)[0];
          element["selectName"] = keyDataFromFetch;
        });
      }
      return data;
    },

    ...mapActions("finesPagination", ["getFinesAll"]),
  },
  mounted() {
    this.loadData();
  },
  beforeMount() {},
  created() {
    this.activateTab = this.dataLang["register_object_owners_text_3"];
  },
  computed: {
    ...mapState("translationModule", ["dataLang"]),
    ...mapState("userSettingModule", ["userSetting"]),
    // ...mapState("finesPagination", ["paginationFinesStateParams"]),
    // ...mapGetters("finesPagination", ["numPages"]),

    computedTabParams() {
      switch (this.activateTab) {
        case this.dataLang["register_object_owners_text_3"]:
          return {
            url: "fiz",
          };
        case this.dataLang["register_object_owners_text_4"]:
          return {
            url: "ip",
          };
        case this.dataLang["register_object_owners_text_5"]:
          return {
            url: "ur",
          };
      }
    },

    columns() {
      if (this.activateTab == this.dataLang["register_object_owners_text_3"]) {
        return [
          {
            field: "",
            key: "a62",
            type: "checkbox",
            title: "",
            width: "2%",
            align: "center",
          },
          {
            field: "object_owners__id",
            key: "1622336",
            title: "ID",
            align: "center",
            width: "10%",
            ellipsis: {
              showTitle: true,
              lineClamp: 1,
            },
          },
          {
            field: "object_owners_fiz__fio",
            key: "534534543",
            title: this.dataLang["register_object_owners_text_10"],
            align: "center",
            width: "10%",
            ellipsis: {
              showTitle: true,
              lineClamp: 1,
            },
          },
          {
            field: "object_owners_fiz__date_of_birth",
            key: "62341",
            title: this.dataLang["register_object_owners_text_11"],
            align: "center",
            width: "10%",
            ellipsis: {
              showTitle: true,
              lineClamp: 1,
            },
            renderBodyCell: ({ row, column, rowIndex }, h) => {
              return (
                <span
                  title={
                    row.object_owners_fiz__date_of_birth
                      ? this.$time(row.object_owners_fiz__date_of_birth).format(
                          `${this.userSetting.company__tempalte_date}`
                        )
                      : ""
                  }
                >
                  {row.object_owners_fiz__date_of_birth
                    ? this.$time(row.object_owners_fiz__date_of_birth).format(
                        `${this.userSetting.company__tempalte_date}`
                      )
                    : ""}
                </span>
              );
            },
          },
          {
            field: "object_owners_fiz__passport",
            key: "1334441",
            title: this.dataLang["register_object_owners_text_12"],
            align: "center",
            width: "10%",
            ellipsis: {
              showTitle: true,
              lineClamp: 1,
            },
          },
          {
            field: "object_owners_fiz__passport_created_by",
            key: "1334871",
            title: this.dataLang["register_object_owners_text_13"],
            align: "center",
            width: "10%",
            ellipsis: {
              showTitle: true,
              lineClamp: 1,
            },
          },
          {
            field: "object_owners_fiz__passport_created_at",
            key: "1337641",
            title: this.dataLang["register_object_owners_text_14"],
            align: "center",
            width: "10%",
            ellipsis: {
              showTitle: true,
              lineClamp: 1,
            },
            renderBodyCell: ({ row, column, rowIndex }, h) => {
              return (
                <span
                  title={
                    row.object_owners_fiz__passport_created_at
                      ? this.$time(
                          row.object_owners_fiz__passport_created_at
                        ).format(`${this.userSetting.company__tempalte_date}`)
                      : ""
                  }
                >
                  {row.object_owners_fiz__passport_created_at
                    ? this.$time(
                        row.object_owners_fiz__passport_created_at
                      ).format(`${this.userSetting.company__tempalte_date}`)
                    : ""}
                </span>
              );
            },
          },
          {
            field: "object_owners_fiz__passport_code",
            key: "133341",
            title: this.dataLang["register_object_owners_text_15"],
            align: "center",
            width: "10%",
            ellipsis: {
              showTitle: true,
              lineClamp: 1,
            },
          },
          {
            field: "object_owners_fiz__address",
            key: "13132341",
            title: this.dataLang["register_object_owners_text_16"],
            align: "center",
            width: "10%",
            ellipsis: {
              showTitle: true,
              lineClamp: 1,
            },
          },
          {
            field: "object_owners_fiz__phone",
            key: "1313341",
            title: this.dataLang["register_object_owners_text_17"],
            align: "center",
            width: "10%",
            ellipsis: {
              showTitle: true,
              lineClamp: 1,
            },
          },
        ];
      }
      if (this.activateTab == this.dataLang["register_object_owners_text_4"]) {
        return [
          {
            field: "",
            key: "a62",
            type: "checkbox",
            title: "",
            width: "2%",
            align: "center",
          },
          {
            field: "object_owners__id",
            key: "1622336",
            title: "ID",
            align: "center",
            width: "10%",
            ellipsis: {
              showTitle: true,
              lineClamp: 1,
            },
          },
          {
            field: "object_owners_ip__name",
            key: "534534543",
            title: this.dataLang["register_object_owners_text_54"],
            align: "center",
            width: "10%",
            ellipsis: {
              showTitle: true,
              lineClamp: 1,
            },
          },
          {
            field: "object_owners_ip__tax_system",
            key: "62341",
            title: this.dataLang["register_object_owners_text_55"],
            align: "center",
            width: "10%",
            ellipsis: {
              showTitle: true,
              lineClamp: 1,
            },
            renderBodyCell: ({ row, column, rowIndex }, h) => {
              return (
                <span>
                  {row.object_owners_ip__tax_system
                    ? this.dataLang[row.object_owners_ip__tax_system]
                    : ""}
                </span>
              );
            },
          },
          {
            field: "object_owners_ip__inn",
            key: "1334441",
            title: this.dataLang["register_object_owners_text_56"],
            align: "center",
            width: "10%",
            ellipsis: {
              showTitle: true,
              lineClamp: 1,
            },
          },
          {
            field: "object_owners_ip__rs",
            key: "1337641",
            title: this.dataLang["register_object_owners_text_58"],
            align: "center",
            width: "10%",
            ellipsis: {
              showTitle: true,
              lineClamp: 1,
            },
          },
          {
            field: "object_owners_ip__ks",
            key: "133341",
            title: this.dataLang["register_object_owners_text_59"],
            align: "center",
            width: "10%",
            ellipsis: {
              showTitle: true,
              lineClamp: 1,
            },
          },
          {
            field: "object_owners_ip__bik",
            key: "13132341",
            title: this.dataLang["register_object_owners_text_60"],
            align: "center",
            width: "10%",
            ellipsis: {
              showTitle: true,
              lineClamp: 1,
            },
          },
          {
            field: "object_owners_ip__phone",
            key: "1313341",
            title: this.dataLang["register_object_owners_text_61"],
            align: "center",
            width: "10%",
            ellipsis: {
              showTitle: true,
              lineClamp: 1,
            },
          },
        ];
      }
      if (this.activateTab == this.dataLang["register_object_owners_text_5"]) {
        return [
          {
            field: "",
            key: "a62",
            type: "checkbox",
            title: "",
            width: "2%",
            align: "center",
          },
          {
            field: "object_owners__id",
            key: "1622336",
            title: "ID",
            align: "center",
            width: "10%",
            ellursis: {
              showTitle: true,
              lineClamp: 1,
            },
          },
          {
            field: "object_owners_ur__name",
            key: "534534543",
            title: this.dataLang["register_object_owners_text_54"],
            align: "center",
            width: "10%",
            ellursis: {
              showTitle: true,
              lineClamp: 1,
            },
          },
          {
            field: "object_owners_ur__ogrn",
            key: "62341",
            title: this.dataLang["register_object_owners_text_55"],
            align: "center",
            width: "10%",
            ellursis: {
              showTitle: true,
              lineClamp: 1,
            },
          },
          {
            field: "object_owners_ur__inn",
            key: "1334441",
            title: this.dataLang["register_object_owners_text_56"],
            align: "center",
            width: "10%",
            ellursis: {
              showTitle: true,
              lineClamp: 1,
            },
          },
          {
            field: "object_owners_ur__kpp",
            key: "13334441",
            title: this.dataLang["register_object_owners_text_65"],
            align: "center",
            width: "10%",
            ellursis: {
              showTitle: true,
              lineClamp: 1,
            },
          },
          {
            field: "object_owners_ur__rs",
            key: "1337641",
            title: this.dataLang["register_object_owners_text_58"],
            align: "center",
            width: "10%",
            ellursis: {
              showTitle: true,
              lineClamp: 1,
            },
          },
          {
            field: "object_owners_ur__ks",
            key: "133341",
            title: this.dataLang["register_object_owners_text_59"],
            align: "center",
            width: "10%",
            ellursis: {
              showTitle: true,
              lineClamp: 1,
            },
          },
          {
            field: "object_owners_ur__bik",
            key: "13132341",
            title: this.dataLang["register_object_owners_text_60"],
            align: "center",
            width: "10%",
            ellursis: {
              showTitle: true,
              lineClamp: 1,
            },
          },
          {
            field: "object_owners_ur__phone",
            key: "1313341",
            title: this.dataLang["register_object_owners_text_61"],
            align: "center",
            width: "10%",
            ellursis: {
              showTitle: true,
              lineClamp: 1,
            },
          },
        ];
      }
    },
  },
};
</script>
